import { DesignProp, LayoutProp } from "../PropCategories";

export const justifyContent = {
  prop: "style-attribute",
  name: "Item Distribution",
  nameI18n: "builder_ui.prop_type.styles.item_distribution",
  category: [DesignProp, LayoutProp],
  type: "select",
  defaultValue: "flex-start",
  options: [
    {
      label: "Start",
      labelI18n: "builder_ui.prop_type.styles.item_distribution_types.start",
      value: "flex-start",
    },
    {
      label: "End",
      labelI18n: "builder_ui.prop_type.styles.item_distribution_types.end",
      value: "flex-end",
    },
    {
      label: "Space Between Items",
      labelI18n:
        "builder_ui.prop_type.styles.item_distribution_types.space_between",
      value: "space-between",
    },
    {
      label: "Space Around Items",
      labelI18n:
        "builder_ui.prop_type.styles.item_distribution_types.space_around",
      value: "space-around",
    },
    {
      label: "Space Evenly",
      labelI18n:
        "builder_ui.prop_type.styles.item_distribution_types.space_evenly",
      value: "space-evenly",
    },
  ],
} as const;
